import { useEffect, useRef, useState } from 'react';
import classes from './Organization.module.css';

const Member = ({ member, saving, onSaveRole, canEdit = false }) => {
  const [selectedRoles, setSelectedRoles] = useState(
    Array.isArray(member?.roles) && member.roles.length > 0
      ? [...member.roles]
      : ['administration']
  );
  const [showSelect, setShowSelect] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelectedRoles(
      Array.isArray(member?.roles) && member.roles.length > 0
        ? [...member.roles]
        : ['administration']
    );
  }, [member?._id, member?.id, member?.roles]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowSelect(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleRoleToggle = (value) => {
    if (value === 'owner') return;
    setSelectedRoles((prev) => {
      if (prev.includes(value)) {
        if (prev.length === 1) return prev;
        return prev.filter((r) => r !== value);
      }
      return [...prev, value];
    });
  };

  const roleOptions = [
    { value: 'administration', label: 'Administration' },
    { value: 'technical', label: 'Technical' },
  ];

  if (member?.roles?.some((r) => r === 'owner')) {
    roleOptions.push({ value: 'owner', label: 'Owner' });
  }

  const selectedLabels = roleOptions
    .filter((r) => selectedRoles.includes(r.value))
    .map((r) => r.label)
    .join(', ');

  const memberRoles = Array.isArray(member?.roles) ? member.roles : [];
  const arraysEqual =
    selectedRoles.length === memberRoles.length &&
    [...selectedRoles].sort().every((v, i) => v === [...memberRoles].sort()[i]);

  return (
    <div className={classes.memberRow}>
      <div className={classes.memberEmailRow}>
        <label className={classes.label}>Email</label>
        <span className={classes.value}>{member.email || '—'}</span>
      </div>

      <div className={classes.selectRow}>
        <label className={classes.label}>Roles</label>
        {canEdit ? (
          <div className={classes.dropdownWrapper} ref={dropdownRef}>
            <button
              type="button"
              className={classes.dropdownTrigger}
              onClick={() => setShowSelect((p) => !p)}
              disabled={saving}
            >
              <span className={classes.dropdownTriggerText}>
                {selectedLabels || 'Select roles'}
              </span>
              <span className={classes.dropdownArrow}>{showSelect ? '▲' : '▼'}</span>
            </button>
            {showSelect && (
              <ul className={classes.dropdownMenu}>
                {roleOptions.map((r) => (
                  <li
                    key={r.value}
                    className={classes.dropdownItem}
                    onClick={() => handleRoleToggle(r.value)}
                  >
                    <span
                      className={`${classes.checkbox} ${
                        selectedRoles.includes(r.value) ? classes.checkboxChecked : ''
                      }`}
                    />
                    <span className={classes.dropdownItemLabel}>{r.label}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ) : (
          <span className={classes.value}>{selectedLabels || '—'}</span>
        )}
      </div>

      {canEdit && (
        <div className={classes.memberSaveButtonRow}>
          <button
            className={classes.memberSaveButton}
            onClick={() => onSaveRole?.(member?._id || member?.id, selectedRoles)}
            disabled={saving || arraysEqual}
            type="button"
          >
            Save
          </button>
        </div>
      )}
    </div>
  );
};

export default Member;
